<template>
  <div class="choiceSuccess main-panel">
    <div class="main main-step-paysuccess">
      <z-steps :step="3" style="background:#fafafa;"></z-steps>
      <div class="detail" v-if="![4,5].includes(type)">
        <div class="leftMsg">
          <div class="title-top">线下汇款成功</div>
          <div class="title">
            <span class="orderType">
              支付内容：
              <span v-if="orderDetail.paymentStage">{{orderDetail.paymentStage}}</span>
              <span v-else>{{orderDetail.subject}}</span>
              <span v-if="orderDetail.paymentStagePercent">（{{orderDetail.paymentStagePercent}}%）</span>
            </span>
          </div>
          <div class="orderNum">
            订单号：
            <span>{{orderDetail.orderCode || orderDetail.code}}</span>
          </div>
          <div class="shouldPay">
            应付：
            <span>{{orderDetail.amountDisplay || orderDetail.amount | currency('¥','2')}}</span>
          </div>
        </div>
      </div>
      <div class="showMsg">
        <i class="iconfont icon-wancheng"></i>
        <p>感谢您的支持！</p>
        <span style="display:block;margin-top: 22px;color: #353838;font-size: 14px;">
          {{config.text}}将在
          <span style="color:red;">1～3日内</span>为您确认付款，请您耐心等待
        </span>
        <div class="rightButton">
          <a :href="nuxtUrl" class="other" style="margin-top: 77px; margin-left: -10px;">继续逛逛 ></a>
          <a
            v-if="orderId"
            style="margin-left:-80px;"
            class="button"
            :href="VUE_APP_NEXT_BASIC_URL + '/details/' + orderId"
          >查看订单</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const VUE_APP_NEXT_BASIC_URL = process.env.VUE_APP_NEXT_BASIC_URL;
import searchBox from "../../../common/searchBox.vue";
import api from "../../../../api";
import config from "../../../../config/config";
import Pay from "../../../../mixins/pay";
export default {
  mixins: [Pay],
  data() {
    return {
      VUE_APP_NEXT_BASIC_URL: VUE_APP_NEXT_BASIC_URL,
      nuxtUrl: process.env.VUE_APP_NUXT_BASIC_URL,
      orderDetail: "",
      orderId: this.$route.params.id,
      type: this.$route.params.type,
      config: config
    };
  },

  berforRouteEnter(to, from, next) {
    setTimeout(() => {
      api.pay
        .payMentInfo_offLine(to.params.id, to.query.paymentId)
        .then(res => {
          next(vm => {
            vm.orderDetail = res;
          });
        });
    }, 500);
  },

  methods: {
    getPayInfo() {
      setTimeout(_ => {
        api.pay
          .payMentInfo_offLine(this.orderId, this.$route.query.paymentId)
          .then(res => {
            this.orderDetail = res;
          });
      }, 500);
    }
  },
  components: {
    searchBox
  },
  created() {
    this.getPayInfo();
  }
};
</script>

<style scoped>
.choiceSuccess {
  padding: 30px 0 10px;
}
.choiceSuccess .main {
  width: 1200px;
  margin: 0px auto;
  margin-bottom: 0;
  /* padding: 40px; */
}
.choiceSuccess .main .showMsg {
  /* height: 331px; */
  padding-bottom: 80px;
  text-align: center;
  background: #fff;
}
.choiceSuccess .main .showMsg i {
  display: inline-block;
  color: rgba(147, 219, 69, 0.9);
  font-size: 60px;
  margin-top: 60px;
}
.choiceSuccess .main .showMsg p {
  font-size: 22px;
  color: #15161b;
  margin-top: 10px;
}
.choiceSuccess .main .detail {
  width: 100%;
  min-height: 193px;
  background: #fff;
  border-radius: 4px;
  padding: 20px;
  margin-top: 30px;
  margin-bottom: 30px;
}
.choiceSuccess .main .detail:after {
  content: "";
  display: block;
  clear: both;
}
.choiceSuccess .main .detail .leftMsg {
  float: left;
  width: 100%;
}
.choiceSuccess .main .detail .leftMsg .title-top {
  font-size: 18px;
  font-weight: 500;
  color: #313131;
  border-bottom: 1px solid #e7e7e7;
  width: 100%;
  margin-bottom: 20px;
  padding: 10px 0;
}
.choiceSuccess .main .detail .leftMsg .title {
  font-size: 16px;
  color: #707070;
  width: 100%;
  padding-left: 20px;
}
.choiceSuccess .main .detail .leftMsg .title .orderType {
  color: #707070;
}
.choiceSuccess .main .detail .leftMsg .title .orderType span {
  color: #313131;
}
.choiceSuccess .main .detail .leftMsg .orderNum {
  font-size: 16px;
  color: #707070;
  margin-top: 10px;
  padding-left: 20px;
}
.choiceSuccess .main .detail .leftMsg .orderNum span {
  color: #313131;
}
.choiceSuccess .main .detail .leftMsg .paynNum {
  font-size: 14px;
  color: #353838;
  margin-top: 4px;
}
.choiceSuccess .main .detail .leftMsg .shouldPay {
  font-size: 16px;
  color: #707070;
  padding-left: 20px;
  margin-top: 8px;
}
.choiceSuccess .main .detail .leftMsg .shouldPay span {
  color: #313131;
}
.choiceSuccess .main .detail .leftMsg .shouldPay span {
  font-size: 16px;
  color: #e14b5d;
}
.choiceSuccess .main .detail .leftMsg .Paid {
  font-size: 14px;
  color: #353838;
  margin-top: 4px;
}
.choiceSuccess .main .detail .leftMsg .Paid > span {
  color: #e14b5d;
}
.choiceSuccess .main .rightButton {
  position: relative;
}
.choiceSuccess .main .rightButton .hetong {
  float: right;
  margin-top: 127px;
  margin-right: 30px;
}
.choiceSuccess .main .rightButton .hetong p {
  font-size: 12px;
  color: #6c6f70;
}
.choiceSuccess .main .rightButton .hetong span {
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: #353838;
  letter-spacing: 0;
  text-decoration: underline;
  cursor: pointer;
  margin-top: 10px;
}
.choiceSuccess .main .rightButton .hetong span.specail {
  color: #6c6f70;
  text-decoration: none;
  cursor: default;
}
.choiceSuccess .main .rightButton .hetong span:hover {
  color: #6c6f70;
}
.choiceSuccess .main .rightButton .hetong i {
  font-size: 15px;
  color: #e14b5d;
  margin-top: 10px;
}
.choiceSuccess .main .rightButton .other {
  position: absolute;
  left: 670px;
  display: inline-block;
  font-size: 14px;
  color: #6c6f70;
  margin-top: 97px;
  text-decoration: underline;
}
.choiceSuccess .main .rightButton .button {
  display: inline-block;
  width: 145px;
  height: 40px;
  margin-top: 70px;
  text-align: center;
  line-height: 40px;
  background: #e56a69;
  border-radius: 4x;
  font-size: 14px;
  color: #ffffff;
}
.choiceSuccess .main .rightButton .specail-button {
  margin-top: 95px;
}
.choiceSuccess .main .showMsg p.router-text {
  font-size: 16px;
  color: #171a1a;
  letter-spacing: 2.4px;
}
.choiceSuccess .main .showMsg p.router-text .red-font {
  font-size: 16px;
}
</style>

<style lang="scss">
.main-step-paysuccess {
  margin-top: -10px;
  .zSteps-common .col-span {
    background: #313131;
  }
  .zSteps-line .line {
    width: 0px !important;
  }
}
</style>